<template>
  <div style="height: 100%">
    <cTable
      ref="table"
      :fields="fields"
      :modals="modals"
      :header="header"
      :methods="methods"
    >
    </cTable>
  </div>
</template>

<script>
import {
  getClaimList,
  auditClaim,
  getAuditRecord,
  getClaimConfig,
  printClaim,
  // getClaimDuty,
  getStatusNav,
  getBindUser,
  bindAuditUser,
  addClaim,
  editClaim,
  cancelClaim,
  deleteClaim,
  uploadFile,
  deleteFile,
  exportClaim,
  createBill,
  setClaim,
  saveExtend,
  getAmount,
  batchAudit,
	Cancel,
	Edit,
	Detail,
	Add,
} from "@/api/finance/claim_list";
import { getClaimDuty } from "@/api/claim_management/responsible_claim";
import { getSelectType, getKeysType } from "@/api/public";
import { getAllService } from "@/api/user/internal";
import { getCountry } from "@/api/system/country";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { mapState } from "vuex";
import print from "./print.vue";
import copyClick from "@/utils/copyClick";
import { getToken } from "@/libs/util";
export default {
  name: "branch_claim_list",
  components: {
    cTable,
    print,
  },
  async mounted() {
    this.selData = (await getClaimConfig()).data.payload;
    // let country = (await getCountry()).data.payload;
    // this.selData.toStation = (await getPort({ type: 2 })).data.payload;
    // this.selData.clearance_agent = (
    //   await getTransportAgent({ type: 3 })
    // ).data.payload;
    // this.tabList = this.selData.label_type;
    // this.tabName = this.tabList[1].type;
    // let allService = (await getAllService()).data.payload;
		console.log(this);
		this.claim_type = this.selData.claim_type;
		this.finance_currency = this.selData.currency;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
      /* if (item.key === "service_id")
        item.options = allService[1]
          .concat(allService[2])
          .concat(allService[3]);
      if (item.key === "salesman_id")
        item.options = (
          await getUser({ roleType: "Salesman" })
        ).data.payload.rows;
      if (item.key === "claim_type") item.options = this.selData.claim_type;
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      // if (item.key === "status") item.options = this.selData.status_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      if (item.key === "verify_status") item.options = this.selData.verify_type;
      if (item.key === "is_claim_agent")
        item.options = this.selData.is_claim_agent;
      if (item.key === "node_type") item.options = this.selData.node_type;
      if (item.key === "to_country" || item.key === "from_country")
        item.options = country.rows; */
    });
   /* this.modals["auditOrder"]["fields"].forEach(async (item) => {
      if (item.key === "currency") item.options = this.selData.currency;
      if (item.key === "actual_currency") item.options = this.selData.currency;
      if (item.key === "finance_currency") item.options = this.selData.currency;
      if (item.key === "pay_currency") item.options = this.selData.currency;
      if (item.key === "scheme_id") item.options = this.selData.scheme_type;
      if (item.key === "claim_agent_currency")
        item.options = this.selData.currency;
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      if (item.key === "customer_rule") item.options = this.selData.claim_rule;
    });
    this.modals["batchClaim"]["fields"].forEach(async (item) => {
      if (item.key === "traceker_code")
        item.options = this.selData.is_claim_agent;
    }); */
  },
  methods: {
    getAmount(row) {
      getAmount(row).then((res) => {
        if (res.data.status) {
          row.actual_amount = res.data.payload.amount;
        }
      });
    },
    // 打印
    printFun(obj) {
      printClaim(obj).then((res) => {
        // if (res.data.payload.length) {
        this.printData = res.data.payload;
        // }
        // this.$refs["print"].print();
      });
    },
    // tab切换
    handleTab() {
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    },
    // 获取颜色
    getColor(status) {
      let color = "";
      switch (status) {
        case 1:
          color = "#ff9900";
          break;
        case 3:
          color = "#ff9900";
          break;
        case 2:
          color = "#ed4014";
          break;
        case 99:
          color = "#19be6b";
          break;
        default:
          color = "#606266";
          break;
      }
      return color;
    },
  },
  computed: {
    ...mapState({
      remindId: (state) => state.app.remindId,
    }),
  },
  watch: {
    remindId(newVal) {
      if (newVal) {
        this.$refs["table"].$refs["header"].searchForm["keywords"] = newVal;
        this.$refs["table"].getList();
        this.$store.commit("remindIdFun", 0);
      }
    },
  },
  data() {
    let that = this;
    return {
			finance_currency:[],
			claim_type:[],
      printData: {},
      selData: {},
      title: "",
      required: false,
      tabList: [],
      tabName: "",
      methods: {
        list: async (params) => {
          this.tabList = (await getStatusNav()).data.payload;
          if (!this.tabName) {
            this.tabName = this.tabList[1].num
              ? this.tabList[1].status
              : this.tabList[0].status;
          }
          params.status = this.tabName;
          return getClaimList(params);
        },
        auditClaim,
        getAuditRecord,
        getSelectType,
        getKeysType,
        printClaim,
        print: (obj) => {
          this.printFun(obj);
        },
        getClaimDuty,
        bindAuditUser,
        addClaim,
        editClaim,
        cancelClaim,
        deleteClaim,
        exportClaim,
        createBill,
        setClaim,
        saveExtend,
        getAmount,
        batchAudit,
				Detail,
				Cancel,
				Edit,
				Add,
        // getZhongGangList,
        // getZhongGangCount
      },
      modals: {
				edit:{
					slots:['UPLOAD'],
					methods:{
						ok({close,row,fields}){
							console.log(row,fields,arguments)
							row["extend"] = row["files"];
							this.$page.handleRequestMethods(row.id?'Edit':'Add', row).then(()=>{
								this.$page.getList()
								close()
							})
							console.log(extend)
						},
						cancel(){
							this.fields.map(field=>{
								if(field.key === 'files'){
									field.files = []
								}
							})
						}
					},
					grid:[
						{airway_number:24},
						// {order_type:24},
						{claim_type:24},
						{other_claim:24},
						// {claim_rule:24},
						{customer_explain:24},
						{finance_currency:24},
						{quantity:8,weight:8,volume:8},
						{is_pay:24},
						{currency:12,amount:12,},
						{remarks:24},
						{files:24},
					],
					config:{
						formBind:{
							'label-width':100
						},
						width:800,
						rowBind: {
						  gutter: 13,
						  style: {
						    marginBottom: "20px",
						  },
						},
						rules:{
							order_type:[{required:true,message:'请选择订单类型'}],
							airway_number:[{required:true,message:'请输入理赔单号'}],
							claim_type:[{required:true,message:'请选择理赔类型'}],
							other_claim:[{required:true,message:'请输入其他原因'}],
							order_type:[{required:true,message:'请输入正确的订单号获取订单类型'}],
							currency:[{required:true,message:'请选择币种'}]
						},
					},
					fields:[
						{
							name:'理赔单号',
							key:'airway_number',
							component:'Input',
							bind:{
								type: 'textarea',
								autosize: {
									minRows: 2,
									maxRows: 5
								}
							},
							disabled(){
								return !!this.$modal.params.id
							},
							methods:{
								'on-blur'({formData,fields}){
									if(formData.airway_number)
									this.$page.handleRequestMethods('getOrderType',{airway_number:formData.airway_number}).then((res)=>{
										console.log(res)
										formData.order_type = res.payload
										// this.$page.handleRequestMethods('getAmount',formData).then(res=>{
										// 	fields.forEach((field)=>{
										// 		if(field.key === 'is_pay'){
										// 			field.remark = res.payload.txt
										// 		}
										// 	})
										// 	Object.assign(formData,res.payload)
										// })
									}).catch(err=>{
										formData.order_type = ''
									})
								}
							}
						},
						{
							name:'理赔类型',
							key:'claim_type',
							component:'Select',
							options:[],
							methods:{
								list:({field})=>{
									field.options = this.claim_type
								}
							}
						},
						{
							name:'其他原因',
							key:'other_claim',
							component:'Input',
							show({row}){
								return row.claim_type === 99
							},
						},
						// {
						// 	name:'理赔规则',
						// 	key:'claim_rule',
						// 	component:'Select',
						// 	disabled({formData}){
						// 		return !formData.order_type
						// 	},
						// 	clearable:false,
						// 	options:[],
						// 	methods:{
						// 		list:({field,formData})=>{
						// 			field.options = this.conf.claim_rule
						// 			this.$nextTick(()=>{
						// 				formData.claim_rule = field.options[0].value
						// 			})
						// 		},
						// 		'on-change'({formData,fields}){
						// 			// this.$page.handleRequestMethods('getAmount',formData).then(res=>{
						// 			// 	fields.forEach((field)=>{
						// 			// 		if(field.key === 'is_pay'){
						// 			// 			field.remark = res.payload.txt
						// 			// 		}
						// 			// 	})
						// 			// 	Object.assign(formData,res.payload)
						// 			// })
						// 		}
						// 	}
						// },
						{
							name:'特殊说明',
							key:'customer_explain',
							component:'Input',
							show({row}){
								return row.claim_rule === 2
							},
						},
						// {
						// 	name:'订单类型',
						// 	key:'order_type',
						// 	component:'Select',
						// 	placeholder:'自动获取',
						// 	options:[],
						// 	disabled(){
						// 		return !!this.$modal.params.id
						// 	},
						// 	disabled:true,
						// 	methods:{
						// 		list:({field})=>{
						// 			field.options = this.conf.order_type
						// 		}
						// 	}
						// },
						{
							name:'件数',
							key:'quantity',
							component:'InputNumber',
							default:0,
							show({row}){
								return row.order_type === 2
							},
							bind:{
								style:'width:100%'
							}
						},
						{
							name:'重量',
							key:'weight',
							default:0,
							component:'InputNumber',
							show({row}){
								return row.order_type === 2
							},
							bind:{
								style:'width:100%'
							}
						},
						{
							name:'方数',
							key:'volume',
							component:'InputNumber',
							default:0,
							show({row}){
								return row.order_type === 2
							},
							bind:{
								style:'width:100%'
							}
						},
						{
							name:'备注',
							key:'remarks',
							component:'Input',
							bind:{
								type:'textarea'
							},
							options:[]
						},
						{
							name:'理赔币种',
							key:'currency',
							component:'Select',
							placeholder:'请选择理赔币种',
							options:[],
							methods:{
								list:({field,formData})=>{
									field.options = this.finance_currency
									this.$nextTick(() => {
										formData.currency = field.options[0].value
									});
								}
							}
						},
						{
							name:'理赔金额',
							key:'amount',
							component:'InputNumber',
							default:0,
							bind:{
								style:'width:100%'
							}
						},
						{
						  name: () => this.$t("Evidence_file"),
						  key: "files",
						  component: "Upload",
						  bind: {
						    fileName: "files",
						    type: "drag",
						    // accept: ".xlsx,.xls",
						    multiple: true,
						    content: this.$t("uploadText") + this.$t("uploadTe"),
						  },
						  methods: {
						    beforeUpload({ file, row }) {
						      row["file"] = file;
						      return false;
						    },
						  },
						  methods: {
						    beforeUpload: ({ file, row }) => {
						      let formData = new FormData();
						      formData.append("file", file); // 文件对象
						      uploadFile(formData).then((res) => {
						        if (res.data.status) {
						          if (row["files"]) {
						            row["files"].push({
						              name: file.name,
						              url: res.data.payload,
						            });
						          } else {
						            row["files"] = [
						              {
						                name: file.name,
						                url: res.data.payload,
						              },
						            ];
						          }
						        }
						      });
						      return false;
						    },
						    delUpload: ({ file, index, key, row }) => {
						      if (file.id) {
						        this.$refs["table"]
						          .handleRequestMethods("deleteFile", {
						            id: file.id,
						          })
						          .then((res) => {
						            row["files"].splice(index, 1);
						          });
						      } else {
						        row["files"].splice(index, 1);
						      }
						    },
						    fileClick({ row }) {
						      window.open(this.$globalUrl + row.src);
						    },
						  },
						},
					]
				},
        auditOrder: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              if (data.verify_type !== 1) {
                for (const key in data) {
                  if (
                    key != "verify_type" &&
                    key != "verify_remarks" &&
                    key != "id"
                  ) {
                    delete data[key];
                  }
                }
              }
              this.$page
                .handleRequestMethods("auditClaim", data, true, true, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          header: {
            show: () => true,
            copy: true,
            methods: {
              copy({ row }) {
                copyClick.copyToClipboard(row.airway_number, this);
              },
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            tableTop: true,
            modalBind: {
              width: "80%",
              styles: {
                top: "20px",
              },
            },
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;",
            },
            formBind: {
              labelWidth: 170,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              verify_type: [
                {
                  required: true,
                  type: "number",
                  message: "verify type agent cannot be empty",
                  trigger: "change",
                },
              ],
              // actual_amount: [
              //   {
              //     validator: (rule, value, callback) => {
              //       if (value === "") {
              //         callback();
              //       } else if (value < 0 || value > 100) {
              //         callback(new Error("业务申请金额不能超过100USD"));
              //       } else {
              //         callback();
              //       }
              //     },
              //     trigger: "change"
              //   }
              // ]
              // currency: [
              //   {
              //     required: true,
              //     message: "currency cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // amount: [
              //   {
              //     required: true,
              //     message: "amount cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_type: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty type cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_duty: [
              //   {
              //     required: true,
              //     message: "other duty cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // duty_cause: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "duty cause cannot be empty",
              //     trigger: "change"
              //   }
              // ],
              // other_cause: [
              //   {
              //     required: true,
              //     message: "other cause cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              // remarks: [
              //   {
              //     required: false,
              //     message: "remarks cannot be empty",
              //     trigger: "blur"
              //   }
              // ]
            },
          },
          grid: [
            {
              name: () => this.$t("feedbackArea"),
              render: (h, p) => {
                let modal = this.$refs["table"].getModal("auditOrder");
                let text = {
                  1: "请客服审核客户发起信息是否正确，界定责任方，并向责任方发起追赔。",
                  2: "请业务审核客户发起信息是否正确，参考客户发起理赔金额，填入公司赔偿客户金额，填写计算规则，金额的由来，等详细情况。",
                  3: "请财务在实际打款后，输入实际赔偿金额，并点击确认已打款",
                };
                let role = {
                  B2B客服: 1,
                  小包客服: 1,
                  小包主管: 1,
                  操作客服: 1,
                  业务员: 2,
                  业务经理: 2,
                  客服经理: 2,
                  客户管理: 2,
                  "总经理-多角色": 0,
                  财务经理: 3,
                  财务审核: 3,
                };

                let user = modal.list.find((t) => !t.create_time) || {};
                return h("span", {}, [
                  this.$t("feedbackArea"),
                  text[role[user.role]] &&
                    h(
                      "span",
                      {
                        style: "color:#f3c9c9;font-size:10px;margin-left:10px",
                      },
                      modal.params.tip + ":" + text[role[user.role]]
                    ),
                ]);
              },
              span: 24,
              children: [
                { verify_type: 8, claim_type: 8 },
                { amount: 8, currency: 8 },
                { category: 6, quantity: 6, weight: 6, volume: 6 },
                {
                  remarks: 24,
                },
                {
                  values: 8,
                  values_cny: 8,
                  customer_rule: 8,
                },
                {
                  customer_explain: 24,
                },
                {
                  freight: 8,
                  is_pay: 8,
                  pay_currency: 8,
                },
                {
                  is_claim_agent: 8,
                  // is_claim_agent_status: 8,
                  // claim_agent_amount: 8,
                  // claim_agent_currency: 8
                },
                // {
                //   is_claim_agent_pay: 8,
                //   is_claim_agent_date: 8
                // },
                // {
                //   track_status: 8
                // },
                {
                  duty_type: 8,
                  number: 8,
                  duty: 8,
                },
                {
                  other_duty: 8,
                  duty_cause: 8,
                  other_cause: 8,
                },
                {
                  actual_quantity: 8,
                  actual_weight: 8,
                  actual_volume: 8,
                },
                { is_values: 8, is_freight: 16 },
                { scheme_id: 8, other_scheme: 8, scheme_amount: 8 },
                { actual_currency: 8, actual_amount: 8 },
                { finance_amount: 8, finance_currency: 8 },
                { memorandum: 24 },
                { verify_remarks: 24 },
              ],
            },
          ],
          fields: [
            {
              name: () => this.$t("verify_status"),
              key: "verify_type",
              component: "Radio",
              options: [
                { label: this.$t("agree"), value: 1 },
                { label: this.$t("reject_prel"), value: 2 },
              ],
              bind: {
                border: true,
              },
              show: ({ row }) => row.is_show != 4,
              methods: {
                "on-change": ({ value }) => {
                  // if (value == 2) {
                  // }
                },
              },
            },
            {
              key: "currency",
              name: () => this.$t("client_currency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("client_currency");
              },
              options: [],
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "amount",
              name: () => this.$t("client_amount"),
              component: "Input",
              bind: {
                type: "number",
              },
              placeholder() {
                return this.$t("enter") + this.$t("client_amount");
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ formData }) {
                return true;
              },
            },
            {
              key: "is_pay",
              name: () => this.$t("whether") + this.$t("payment_freight"),
              component: "Select",
              options: [
                { label: this.$t("is_paid"), value: 1 },
                { label: this.$t("unpaid"), value: 2 },
              ],
              disabled({ formData, row }) {
                return row.is_show != 5;
              },
            },
            {
              key: "pay_currency",
              name: () => this.$t("freight_fees") + this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("freight_fees") +
                  this.$t("currency_t")
                );
              },
              options: [],
              show({ row }) {
                return row.is_pay == 1;
              },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "freight",
              name: () => this.$t("freight_fees") + "(CNY)",
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return row.is_show != 5;
              },
            },
            {
              key: "values",
              name: () => this.$t("DeclaredValue") + "(USD)",
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "values_cny",
              name: () => this.$t("DeclaredValue") + "(CNY)",
              component: "Input",
              // show({ row }) {
              //   return row.is_show > 1;
              // },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "remarks",
              name: () => this.$t("CustomerNote"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 1 },
              },
              placeholder() {
                return this.$t("CustomerNote");
              },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "customer_rule",
              name: () => this.$t("claim") + this.$t("country_code_validation"),
              component: "Select",
              options: [],
              disabled({ formData }) {
                return true;
              },
            },
            {
              key: "customer_explain",
              name: () => this.$t("b2bClient") + this.$t("special_remark"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("b2bClient") +
                  this.$t("special_remark")
                );
              },
              show({ row }) {
                return row.customer_rule == 2;
              },
              disabled({ row }) {
                return true;
              },
            },
            {
              key: "actual_currency",
              name: () => this.$t("actual_currency"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("actual_currency");
              },
              options: [],
              show({ row }) {
                return row.is_show > 1;
              },
              disabled({ row }) {
                return row.is_show != 2;
              },
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                },
              },
            },
            {
              key: "actual_amount",
              name: () => this.$t("actual_amount"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("actual_amount");
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%",
              },
              show({ row }) {
                return row.is_show > 1;
              },
              disabled({ row }) {
                return row.is_show != 2;
              },
            },
            {
              key: "finance_currency",
              name: () => this.$t("finance_currency"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("finance_currency");
              },
              options: [],
              show({ row }) {
                return row.is_show > 2;
              },
              disabled({ row }) {
                return row.is_show != 3;
              },
            },
            {
              key: "finance_amount",
              name: () => this.$t("finance_amount"),
              component: "Input",
              bind: {
                type: "number",
              },
              placeholder() {
                return this.$t("enter") + this.$t("finance_amount");
              },
              show({ row }) {
                return row.is_show > 2;
              },
              disabled({ row }) {
                return row.is_show != 3;
              },
            },
            {
              key: "duty_type",
              name: () => this.$t("Responsibility_party"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("Responsibility_party");
              },
              options: [],
              disabled({ row }) {
                return row.is_show != 1;
              },
              methods: {
                "on-change"({ value, fields, formData }) {
                  if (value) {
                    fields.forEach(async (el) => {
                      if (el.key == "duty") {
                        formData.duty = undefined;
                        let data = (
                          await getClaimDuty({
                            duty_type: value,
                            airway_number: formData.airway_number,
                            number: formData.number,
                          })
                        ).data.payload;
                        formData["show_weight"] = data.show_weight;
                        fields.forEach(async (el) => {
                          if (
                            el.key == "duty" ||
                            el.key == "number" ||
                            el.key == "other_duty" ||
                            el.key == "duty_cause" ||
                            el.key == "other_cause"
                          ) {
                            formData[el.key] = undefined;
                            el.options = data[el.key];
                            this.$forceUpdate();
                          }
                        });
                      }
                    });
                  }
                },
              },
            },
            {
              key: "duty",
              name: () => this.$t("specific") + this.$t("Responsibility_party"),
              component: "Select",
              options: [],
              show({ row }) {
                return row.duty_type && row.duty_type != 99;
              },
              disabled({ row }) {
                return row.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("specific") +
                  this.$t("Responsibility_party")
                );
              },
            },
            {
              key: "show_weight",
              name: () => this.$t("whether") + this.$t("doubleList"),
              component: "Input",
              show({ row }) {
                return false;
              },
            },
            {
              key: "other_duty",
              name: () => this.$t("orther") + this.$t("Responsibility_party"),
              component: "Input",
              show({ row }) {
                return row.duty_type === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("orther") +
                  this.$t("Responsibility_party")
                );
              },
            },
            {
              key: "duty_cause",
              name: () => this.$t("Responsibility_party") + this.$t("reason"),
              component: "Select",
              options: [],
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
              disabled({ row }) {
                return row.is_show != 1;
              },
            },
            {
              key: "other_cause",
              name: () =>
                this.$t("orther") +
                this.$t("Responsibility_party") +
                this.$t("reason"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 1 },
              },
              show({ row }) {
                return row.duty_cause === 99;
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return (
                  this.$t("orther") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
            },
            {
              name: () => this.$t("whether") + this.$t("claim_application"),
              key: "is_claim_agent",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 1,
                },
                {
                  label: this.$t("NO"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 1,
                },
              ],
              bind: {
                border: true,
              },
            },
            // {
            //   name: () =>
            //     this.$t("Responsibility_party") +
            //     this.$t("whether") +
            //     this.$t("claim_acceptance"),
            //   key: "is_claim_agent_status",
            //   component: "Radio",
            //   options: [
            //     {
            //       label: this.$t("YES"),
            //       value: 1,
            //       disabled: ({ formData }) => formData.is_show != 1
            //     },
            //     {
            //       label: this.$t("NO"),
            //       value: 0,
            //       disabled: ({ formData }) => formData.is_show != 1
            //     }
            //   ],
            //   bind: {
            //     border: true
            //   },
            //   show({ row }) {
            //     return row.is_claim_agent;
            //   },
            //   disabled: ({ row }) => row.is_show != 1
            // },
            {
              key: "claim_agent_amount",
              name: () => this.$t("agent_claim") + this.$t("reChAmount"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("agent_claim") +
                  this.$t("reChAmount")
                );
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%",
              },
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1,
            },
            {
              key: "claim_agent_currency",
              name: () => this.$t("agent_claim") + this.$t("currency_t"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("agent_claim") +
                  this.$t("currency_t")
                );
              },
              options: [],
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1,
            },
            {
              name: () => this.$t("whether") + this.$t("received_agent_claim"),
              key: "is_claim_agent_pay",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 1,
                },
                {
                  label: this.$t("NO"),
                  value: 0,
                  disabled: ({ formData }) => formData.is_show != 1,
                },
              ],
              bind: {
                border: true,
              },
              show({ row }) {
                return row.is_claim_agent == 1;
              },
              disabled: ({ row }) => row.is_show != 1,
            },
            {
              name: () => this.$t("received_agent_claim_date"),
              key: "is_claim_agent_date",
              component: "DatePicker",
              placeholder() {
                return this.$t("select") + this.$t("received_agent_claim_date");
              },
              show({ row }) {
                return row.is_claim_agent == 1 && row.is_claim_agent_pay;
              },
              disabled: ({ row }) => row.is_show != 1,
              bind: {
                type: "datetime",
                style: {
                  width: "100%",
                },
              },
            },

            {
              key: "quantity",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("invoicePCS"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
            },
            {
              key: "weight",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("invoiceWeight"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
            },
            {
              key: "volume",
              name: () =>
                this.$t("b2bClient") +
                this.$t("application") +
                this.$t("square"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
            },
            {
              key: "actual_quantity",
              name: () => this.$t("enter") + this.$t("order_pcs"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_pcs");
              },
            },
            {
              key: "number",
              name: () => this.$t("package_number"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("package_number");
              },
              methods: {
                "on-blur"({ value, fields, formData }) {
                  if (value) {
                    fields.forEach(async (el) => {
                      if (el.key == "duty") {
                        formData.duty = undefined;
                        let data = (
                          await getClaimDuty({
                            duty_type: formData.duty_type,
                            airway_number: formData.airway_number,
                            number: value,
                          })
                        ).data.payload;
                        formData["show_weight"] = data.show_weight;
                        fields.forEach(async (el) => {
                          if (
                            el.key == "duty" ||
                            el.key == "other_duty" ||
                            el.key == "duty_cause" ||
                            el.key == "other_cause"
                          ) {
                            formData[el.key] = undefined;
                            el.options = data[el.key];
                            this.$forceUpdate();
                          }
                        });
                      }
                    });
                  }
                },
              },
            },
            {
              key: "actual_weight",
              name: () =>
                this.$t("service") +
                this.$t("confirm") +
                this.$t("invoiceWeight"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
            },
            {
              key: "actual_volume",
              name: () =>
                this.$t("service") + this.$t("confirm") + this.$t("square"),
              component: "Input",
              // show({ row }) {
              //   return row.order_type == 2;
              // },
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              disabled({ formData }) {
                return formData.is_show != 1;
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
            },
            {
              key: "category",
              name: () => this.$t("is_goods") + this.$t("category_t"),
              component: "Input",
              show({ row }) {
                return row.order_type == 2 && row.category;
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return (
                  this.$t("enter") + this.$t("is_goods") + this.$t("category_t")
                );
              },
            },
            {
              key: "claim_type",
              name: () => this.$t("application_reason"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 1,
              },
              disabled({ formData }) {
                return true;
              },
              placeholder() {
                return this.$t("enter") + this.$t("application_reason");
              },
            },
            {
              name: this.$t("indexes") + this.$t("order_desc"),
              key: "memorandum",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("email_subject") +
                  this.$t("related") +
                  this.$t("content")
                );
              },
              bind: {
                type: "textarea",
              },
            },
            {
              key: "verify_remarks",
              name: () => this.$t("approval_remark"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder({ formData }) {
                return (
                  this.$t("enter") +
                  (formData.is_show == 2
                    ? this.$t("remarkPlaceholder")
                    : this.$t("approval_remark"))
                );
              },
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("DeclaredValue"),
              key: "is_values",
              component: "Radio",
              options: [
                {
                  label: this.$t("YES"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 2,
                },
                {
                  label: this.$t("NO"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 2,
                },
              ],
              bind: {
                border: true,
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                },
              },
            },
            {
              name: () =>
                this.$t("whether") +
                this.$t("claim_pay") +
                this.$t("freight_fees"),
              key: "is_freight",
              component: "Radio",
              default: 0,
              options: [
                {
                  label: this.$t("zx"),
                  value: 0,
                  disabled: ({ formData }) => formData.is_show != 2,
                },
                {
                  label: this.$t("ox"),
                  value: 1,
                  disabled: ({ formData }) => formData.is_show != 2,
                },
                {
                  label: this.$t("tx"),
                  value: 2,
                  disabled: ({ formData }) => formData.is_show != 2,
                },
              ],
              bind: {
                border: true,
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                },
              },
            },
            {
              name: () => this.$t("special") + this.$t("plan_t"),
              key: "scheme_id",
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("plan_t");
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-change": ({ row }) => {
                  this.getAmount(row);
                },
              },
            },
            {
              key: "other_scheme",
              name: () => this.$t("orther") + this.$t("plan_t"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("orther") + this.$t("plan_t");
              },
              show({ formData }) {
                return formData.scheme_id == 1;
              },
              disabled: ({ row }) => row.is_show != 2,
            },
            {
              key: "scheme_amount",
              name: () => this.$t("plan_t") + this.$t("reChAmount"),
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("plan_t") + this.$t("reChAmount")
                );
              },
              bind: {
                min: 0,
                type: "number",
                style: "width:100%",
              },
              disabled: ({ row }) => row.is_show != 2,
              methods: {
                "on-blur": ({ row }) => {
                  this.getAmount(row);
                },
              },
            },
          ],
          table: {
            group: {
              title: this.$t("auditOrder") + this.$t("record"),
            },
            config: {
              height: 200,
              // showOverflow: false,
            },
            fields: [
              {
                name: () => this.$t("approver"),
                key: "operate_name",
                tooltip: true,
                width: 140,
              },
              {
                name: () => this.$t("approval_time"),
                key: "create_time",
                tooltip: true,
                width: 150,
              },
              {
                name: () => this.$t("result"),
                key: "content",
                tooltip: true,
                width: 100,
              },
              {
                name: () => this.$t("approval_remark"),
                key: "remarks",
                tooltip: true,
                minWidth: 200,
              },
              {
                name: () => this.$t("role_t"),
                key: "role",
                tooltip: true,
                width: 120,
              },
            ],
          },
        },
        record: {
          config: {
            listFn: "list",
            modalBind: {
              width: 800,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("approver"),
                key: "operate_name",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("approval_time"),
                key: "create_time",
                tooltip: true,
                minWidth: 130,
              },
              {
                name: () => this.$t("result"),
                key: "content",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("approval_remark"),
                key: "remarks",
                tooltip: true,
                minWidth: 200,
              },
              {
                name: () => this.$t("role_t"),
                key: "role",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        extend: {
          config: {
            listFn: "list",
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          header: {
            show: true,
            btns: [
              {
                name: this.$t("updateFile"),
                type: "upload",
                fnName: "upload",
                bind: {
                  type: "primary",
                  style: "margin-left:10px",
                },
              },
            ],
            methods: {
              upload({ row }) {
                let el = document.createElement("input");
                let that = this;
                let extend = [];
                let length = 0;
                el.type = "file";
                el.multiple = true;
                el.click();
                el.addEventListener("input", function (e) {
                  that.openLoading();
                  console.log(Object.values(this.files));
                  Object.values(this.files).forEach((file) => {
                    let formData = new FormData();
                    formData.append("file", file); // 文件对象
                    uploadFile(formData)
                      .then((res) => {
                        if (res.data.status) {
                          extend.push(res.data.payload);
                        }
                      })
                      .finally(() => {
                        length += 1;
                        if (length === this.files.length) {
                          that.$page
                            .handleRequestMethods("saveExtend", {
                              extend,
                              id: that.params.id,
                            })
                            .then((res) => {
                              that.closeLoading();
                              that.close();
                              that.$page.getList();
                            });
                        }
                      });
                  });
                });
                console.log("chufa");
              },
            },
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("Evidence_file") + this.$t("alipay_name"),
                key: "name",
                tooltip: true,
                minWidth: 100,
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "show",
                    fnName: "showFun",
                    bind: {
                      type: "primary",
                    },
                  },
                ],
                methods: {
                  showFun({ row }) {
                    if (row.is_doc) {
                      window.open(this.$prviewUrl + this.$globalUrl + row.src);
                    } else {
                      window.open(this.$globalUrl + row.src);
                    }
                  },
                },
              },
            ],
          },
        },
        detail: {
          config: {
            title: "B2B" + this.$t("information"),
            formBind: {
              "label-position": "top",
            },
          },
          grid: [
            { quantity: 8, weight: 8, volume: 8 },
            { actual_quantity: 8, actual_weight: 8, actual_volume: 8 },
          ],
          fields: [
            {
              name: this.$t("invoicePCS"),
              key: "quantity",
              align: "center",
            },
            {
              name: this.$t("invoiceWeight") + "(KG)",
              key: "weight",
              align: "center",
            },
            {
              name: this.$t("square") + "(CBN)",
              key: "volume",
              align: "center",
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("invoicePCS"),
              key: "actual_quantity",
              align: "center",
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("Weight") +
                "(KG)",
              key: "actual_weight",
              align: "center",
            },
            {
              name:
                this.$t("amount_actual") +
                this.$t("claim_pay") +
                this.$t("square") +
                "(CBN)",
              key: "actual_volume",
              align: "center",
            },
          ],
          footer: { show: false },
        },
        binding: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("bindAuditUser", row, true)
                .then((res) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          config: {
            rules: {
              operate_id: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ operate_id: 24 }],
          fields: [
            {
              key: "operate_id",
              name: () => this.$t("auditOrder") + this.$t("personnel"),
              component: "Select",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("auditOrder") +
                  this.$t("personnel")
                );
              },
              options: [],
              methods: {
                async list({ row, field }) {
                  await this.$nextTick(async () => {
                    let res = (await getBindUser(row.id)).data.payload;
                    field.options = res;
                    this.$forceUpdate();
                  });
                },
              },
            },
          ],
        },
        claim: {
          methods: {
            ok({ close, row, fields }) {
              row["extend"] = row["files"];
              this.$page
                .handleRequestMethods(
                  row.id ? "editClaim" : "addClaim",
                  row,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              this.fields.map((field) => {
                if (field.key === "files") {
                  field.files = [];
                  field.extend = [];
                }
              });
            },
          },
          grid: [
            { ownership: 24 },
            { airway_number: 24 },
            { order_type: 24 },
            { claim_type: 24 },
            { other_claim: 24 },
            { quantity: 8, weight: 8, volume: 8 },
            { currency: 12, amount: 12 },
            { remarks: 24 },
            { files: 24 },
          ],
          config: {
            formBind: {
              labelWidth: 100,
            },
            width: 800,
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              ownership: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "change",
                  type: "number",
                },
              ],
              order_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              airway_number: [{ required: true }],
              claim_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              other_claim: [{ required: true }],
              currency: [{ required: true, trigger: "change" }],
              amount: [{ required: true, type: "number" }],
            },
          },
          fields: [
            {
              name: () => this.$t("branchOffice"),
              key: "ownership",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("branchOffice");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.ownership;
                },
              },
            },
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: {
                  minRows: 2,
                  maxRows: 5,
                },
              },
            },
            {
              name: () => this.$t("claim") + this.$t("type"),
              key: "claim_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("claim") + this.$t("type");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.claim_type;
                },
              },
            },
            {
              name: () => this.$t("orther") + this.$t("reason"),
              key: "other_claim",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("orther") + this.$t("reason");
              },
              show({ row }) {
                return row.claim_type === 99;
              },
            },
            {
              name: () => this.$t("order_type_t"),
              key: "order_type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("order_type_t");
              },
              options: [],
              methods: {
                list: ({ field }) => {
                  field.options = this.selData.order_type;
                },
              },
            },
            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%",
              },
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              default: 0,
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%",
              },
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
              default: 0,
              show({ row }) {
                return row.order_type === 2;
              },
              bind: {
                type: "number",
                style: "width:100%",
              },
            },

            {
              name: this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
              },
            },
            {
              name: () => this.$t("claim") + this.$t("currency_t"),
              key: "currency",
              component: "Select",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("currency_t")
                );
              },
              options: [],
              methods: {
                list: ({ field, formData }) => {
                  field.options = this.selData.currency;
                  this.$nextTick(() => {
                    formData.currency = field.options[0].value;
                  });
                },
              },
            },
            {
              name: () => this.$t("claim") + this.$t("reChAmount"),
              key: "amount",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("reChAmount")
                );
              },
              default: 0,
              bind: {
                style: "width:100%",
                type: "number",
              },
            },
            {
              name: () => this.$t("Evidence_file"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: "files",
                type: "drag",
                // accept: ".xlsx,.xls",
                multiple: true,
                content: this.$t("uploadText") + this.$t("uploadTe"),
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                },
              },
              methods: {
                beforeUpload: ({ file, row }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  uploadFile(formData).then((res) => {
                    if (res.data.status) {
                      if (row["files"]) {
                        row["files"].push({
                          name: file.name,
                          url: res.data.payload,
                        });
                      } else {
                        row["files"] = [
                          {
                            name: file.name,
                            url: res.data.payload,
                          },
                        ];
                      }
                    }
                  });
                  return false;
                },
              },
            },
          ],
        },
        batchClaim: {
          methods: {
            ok({ row, close }) {
              this.$page
                .handleRequestMethods("setClaim", row, true)
                .then((res) => {
                  this.$page.getList();
                  this.close();
                });
            },
          },
          config: {
            rules: {
              traceker_code: [
                {
                  required: true,
                  type: "number",
                  message: "cannot be empty",
                  trigger: "change",
                },
              ],
            },
            formBind: {
              labelWidth: 120,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{ traceker_code: 24 }],
          fields: [
            {
              key: "traceker_code",
              name: () => this.$t("whether") + this.$t("claim_application"),
              component: "Radio",
              bind: {
                border: true,
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("whether") +
                  this.$t("claim_application")
                );
              },
              options: [],
            },
          ],
        },
        batchAuditOrder: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = JSON.parse(JSON.stringify(row));
              this.$page
                .handleRequestMethods("batchAudit", data, true, true, true)
                .then((e) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: "500",
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              verify_type: [
                {
                  required: true,
                  type: "number",
                  message: "verify type agent cannot be empty",
                  trigger: "change",
                },
              ],
              verify_remarks: [
                {
                  required: true,
                  message: "remarks cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [{ verify_type: 24 }, { verify_remarks: 24 }],
          fields: [
            {
              name: () => this.$t("verify_status"),
              key: "verify_type",
              component: "Radio",
              options: [
                { label: this.$t("agree"), value: 1 },
                { label: this.$t("reject"), value: 2 },
              ],
              bind: {
                border: true,
              },
            },
            {
              key: "verify_remarks",
              name: () => this.$t("approval_remark"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("approval_remark");
              },
            },
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: { label: "account", value: "id" },
            bind: {
              style: "width:150px",
            },
          },
          // {
          //   key: "service_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("serviceAccount");
          //   },
          //   clearable: true,
          //   options: [],
          //   // config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          // {
          //   key: "salesman_id",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("salesman");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "account", value: "id" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          // {
          //   key: "claim_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("claim") + this.$t("reason");
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "duty_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("Responsibility_party");
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "duty_cause",
          //   placeholder() {
          //     return (
          //       this.$t("select") +
          //       this.$t("Responsibility_party") +
          //       this.$t("reason")
          //     );
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("claim") + this.$t("tip");
          //   },
          //   component: "Select",
          //   options: []
          // },
          // {
          //   key: "verify_status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("verify_status");
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "is_claim_agent",
          //   placeholder() {
          //     return this.$t("whether") + this.$t("claim_application");
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "node_type",
          //   placeholder() {
          //     return this.$t("select") + this.$t("claim") + this.$t("source");
          //   },
          //   component: "Select",
          //   options: [],
          // },
          // {
          //   key: "keywordsType",
          //   placeholder() {
          //     return this.$t("select") + this.$t("keyword") + this.$t("type");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row }) {
          //       return this.$t(row.label);
          //     }
          //   },
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getKeysType("EXTRACT_SEA_KEYWORDS")).data
          //         .payload;
          //       field.options = res;
          //       searchForm[field.key] = res[0].value;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          // {
          //   key: "from_country",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("allow_depart");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "code", value: "code" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          // {
          //   key: "to_country",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("allow_arrive");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "code", value: "code" },
          //   bind: {
          //     style: "width:150px",
          //   },
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
            default: this.$route.params.id ? this.$route.params.id : "",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            // {
            //   name: () =>
            //     this.$t("launch") + this.$t("branchOffice") + this.$t("claim"),
            //   type: "claim",
            //   fnName: "claimFun",
            //   bind: {
            //     type: "warning",
            //     icon: "md-arrow-round-up"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download",
              },
							disabled(row) {
							    return !this.selectAll.length;
							  },
            },
            // {
            //   name: () => this.$t("generate_claim_bill"),
            //   type: "claimBill",
            //   fnName: "claimBillFun",
            //   bind: {
            //     type: "warning",
            //     icon: "md-arrow-round-up",
            //   },
            //   id: 985,
            // },
            // {
            //   name: () => this.$t("batch_claim"),
            //   type: "batchClaim",
            //   fnName: "batchClaimFun",
            //   bind: {
            //     type: "success",
            //     icon: "logo-yen",
            //   },
            //   disabled(row) {
            //     return !this.selectAll.length;
            //   },
            // },
            // {
            //   name: () => this.$t("batch") + this.$t("auditOrder"),
            //   type: "batchAudit",
            //   fnName: "batchAuditFun",
            //   bind: {
            //     type: "success",
            //     icon: "ios-people",
            //   },
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   id: 1105,
            // },
            // disabled(row) {
            //   return !this.selectAll.length;
            //
          ],
          methods: {
            batchAuditFun({ row }) {
              this.getModal("batchAuditOrder").open(
                {
                  ids: this.selectAll.map((item) => item.id),
                },
                function () {
                  this.setTitle(this.$t("batch") + this.$t("auditOrder"));
                }
              );
            },
            // analysisFun({ field, searchForm }) {
            //   this.getModal("analysis").open({}, function() {
            //     this.setTitle(this.$t("analysis"));
            //   });
            // },
            exportFun({ row, field, searchForm }) {
              // let data = JSON.parse(JSON.stringify(searchForm));
              // data["status"] = that.tabName;
              // this.handleRequestMethods("exportClaim", data, true, true).then(
              //   (res) => {
              //     window.open(this.$globalUrl + res.payload.src);
              //   }
              // );
							this.exportExc()
            },
            claimBillFun({ searchForm }) {
              let data = {
                status: that.tabName,
                ...searchForm,
              };
              console.log(data);
              this.$Modal.confirm({
                title: this.$t("generate_claim_bill"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("createBill", data, true, true);
                },
              });
            },
            batchClaimFun() {
              this.getModal("batchClaim").open(
                { ids: this.selectAll.map((item) => item.id) },
                function () {
                  this.setTitle(this.$t("batch_claim"));
                }
              );
            },
            // claimFun() {
            //   this.getModal("claim").open({}, function() {
            //     this.setTitle(
            //       this.$t("launch") + this.$t("branchOffice") + this.$t("claim")
            //     );
            //   });
            // }
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("Application_time"),
          key: "create_time",
          align: "center",
          width: 150,
        },
        {
          name: () => this.$t("Tracking number"),
          key: "airway_number",
          align: "center",
          header: {
            copy: true,
          },
          minWidth: 120,
        },
        {
          name: () => this.$t("placeOrder") + this.$t("time"),
          key: "order_time",
          align: "center",
          width: 160,
        },
				{
				  name: () => this.$t("verify_status"),
				  key: "status_txt",
				  align: "center",
				  minWidth: 120,
				},
        {
          name: () => this.$t("b2bClient") + this.$t("accountNum"),
          key: "customer",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("shipper_company_cn"),
          key: "company",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("claim") + this.$t("type"),
          key: "claim_type",
          align: "center",
          minWidth: 120,
          methods: {
            render({ row }) {
              return row.claim_type;
            },
          },
          render: (h, p) => {
            return h(
              "span",
              {
                style: {
                  color: p.row.type == 2 ? "#ed4014" : "",
                },
              },
              p.row.claim_type
            );
          },
        },
        {
          name: () => this.$t("client_currency"),
          key: "currency",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("client_amount"),
          key: "amount",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("actual_currency"),
          key: "actual_currency",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("actual_amount"),
          key: "actual_amount",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("finance_currency"),
          key: "finance_currency",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("finance_amount"),
          key: "finance_amount",
          align: "center",
          minWidth: 130,
        },
				{
				  name: () => this.$t('CTNS'),
				  key: "quantity",
				  align: "center",
				  minWidth: 130,
				},
				{
					name: () => this.$t('invoiceWeight'),
				  key: "weight",
				  align: "center",
				  minWidth: 130,
				},
				{
					name: () => this.$t('square'),
				  key: "volume",
				  align: "center",
				  minWidth: 130,
				},
				{
				  name: () => this.$t("amount_actual") + this.$t('claim_pay') + this.$t('CTNS'),
				  key: "actual_quantity",
				  align: "center",
				  minWidth: 130,
				},
				{
					name: () => this.$t("amount_actual") + this.$t('claim_pay') + this.$t('invoiceWeight'),
				  key: "actual_weight",
				  align: "center",
				  minWidth: 130,
				},
				{
					name: () => this.$t("amount_actual") + this.$t('claim_pay') + this.$t('square'),
				  key: "actual_volume",
				  align: "center",
				  minWidth: 130,
				},
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("freight_fees"),
          key: "freight",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("b2bClient") + this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100,
        },

        // {
        //   name: () => this.$t("Evidence_file"),
        //   key: "extend",
        //   align: "center",
        //   component: "Button",
        //   minWidth: 100,
        //   bind: {
        //     type: "primary",
        //     size: "small"
        //   },
        //   // render: (h, params) => {
        //   //   return h(
        //   //     "Button",
        //   //     {
        //   //       props: {
        //   //         type: "primary",
        //   //         size: "small"
        //   //       },
        //   //       on: {
        //   //         click: () => {
        //   //           console.log(this);
        //   //           this.$refs["table"]
        //   //             .getModal("extend")
        //   //             .open(null, function() {
        //   //               this.title = this.$t("Evidence_file");
        //   //               this.list = params.row.extend;
        //   //             });
        //   //         }
        //   //       }
        //   //     },
        //   //     this.$t("Evidence_file")
        //   //   );
        //   // },
        //   methods: {
        //     render({ value }) {
        //       return this.$t("Evidence_file");
        //     },
        //     click({ row }) {
        //       this.$page.getModal("extend").open({}, function() {
        //         this.title = this.$t("Evidence_file");
        //         this.list = row.extend;
        //       });
        //     }
        //   }
        // },
        {
          name: () => this.$t("claim") + this.$t("Odd_Numbers"),
          key: "claim_number",
          align: "center",
          minWidth: 220,
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            // {
            //   name: () =>
            //     this.$t("update") + this.$t("branchOffice") + this.$t("claim"),
            //   type: "update",
            //   fnName: "updateFun",
            //   bind: {
            //     type: "warning"
            //   }
            //   // show: ({ row }) => {
            //   //   return row.is_bind == 1 && row.status;
            //   // }
            // },
						{
						  name:'撤销',
						  type: 'cancel',
						  fnName: 'cancel',
							show({row}){
								return row.is_cancel
							},
							bind:{
								type:'success'
							}
						},
						{
						  name:()=>this.$t('edit'),
						  type: 'start',
						  fnName: 'start',
							show({row}){
								return row.is_launch
							},
							bind:{
								type:'primary'
							}
						},
            {
              name: () =>
                this.$t("bind") + this.$t("auditOrder") + this.$t("personnel"),
              type: "bindUser",
              fnName: "bindUserFun",
              bind: {
                type: "warning",
              },
              show: ({ row }) => {
                return row.is_bind == 1 && row.status;
              },
              id: 690,
            },
            {
              name: () => this.$t("Evidence_file"),
              type: "extend",
              fnName: "extendFun",
              bind: {
                type({ row }) {
                  return row.extend && row.extend.length
                    ? "primary"
                    : "default";
                },
              },
            },
            {
              name: () => this.$t("auditOrder") + this.$t("record"),
              type: "record",
              fnName: "recordFun",
              bind: {
                type: "primary",
              },
              id: 679,
            },
            {
              name: () => this.$t("auditOrder"),
              type: "auditOrder",
              fnName: "auditOrderFun",
              bind: {
                type: "success",
              },
              show: ({ row }) => {
                return row.is_verify && row.status;
              },
              id: 681,
            },
            {
              name: () => this.$t("print"),
              type: "print",
              fnName: "printFun",
              bind: {
                type: "warning",
              },
              show: ({ row }) => {
                return row.is_print == 1;
              },
              id: 680,
            },
          ],

          methods: {
						start({row}){
							this.getModal('edit').type = 'add';
							this.handleRequestMethods('Detail',row).then(({payload})=>{
								payload.files = payload.extend
								this.getModal('edit').open(payload,function(){
									this.setTitle('编辑理赔')
									this.fields.map(item=>{
										if(item.key === 'files'){
											item.files = payload.files?payload.files.map(item=>{
												return Object.assign(item,{url:item.src})
											}):[]
										}
									})
								})
							})
						},
						cancel({row}){
								this.$Modal.confirm({
									title:`撤销理赔单（${row.airway_number}）`,
								  content:this.$t('titleModal'),
								  onOk:()=>{
								    this.handleRequestMethods('Cancel',row).then(({payload})=>{
								    	this.getList()
								    })
								  }
								})
						},
            updateFun({ row }) {
              let data = {
                ...row,
                ...row.detail,
                files: row.extend,
              };
              this.getModal("claim").open(data, function () {
                this.setTitle(
                  this.$t("update") + this.$t("branchOffice") + this.$t("claim")
                );
              });
            },
            // exportFun({ row }) {
            //   console.log("导出");
            //   this.openLoading();
            //   this.handleRequestMethods(
            //     "getExportExcel",
            //     row.id,
            //     false,
            //     true
            //   ).then(res => {
            //     console.log(res);
            //     window.open(this.$globalUrl + res.payload);
            //   });
            // },
            bindUserFun({ row }) {
              this.getModal("binding").open({ id: row.id }, function () {
                this.title =
                  this.$t("bind") +
                  this.$t("auditOrder") +
                  this.$t("personnel");
              });
            },
            extendFun({ row }) {
              this.getModal("extend").open({ id: row.id }, function () {
                this.title = this.$t("Evidence_file");
                this.list = row.extend;
              });
            },
            async recordFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id
              );
              this.getModal("record").open(null, function () {
                this.list = res.payload;
                this.setTitle(this.$t("auditOrder") + this.$t("record"));
              });
            },
            async auditOrderFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id,
                false,
                true
              );
              let data = JSON.parse(JSON.stringify(row.detail));
              data["id"] = row.id;
              data["is_show"] = row.is_show;
              data["claim_type"] = row.claim_type;
              data["airway_number"] = row.airway_number;
              // let data = {
              //   ...row,
              //   ...row.detail,
              //   row
              // };
              data.tip = row.verify_status;
              this.getModal("auditOrder").open(data, async function () {
                if (data.is_show == 4) this.hideFooter();
                this.list = res.payload;
                let list = data.type
                  ? (
                      await getClaimDuty({
                        duty_type: data.duty_type,
                        airway_number: data.airway_number,
                        number: data.number,
                      })
                    ).data.payload
                  : {};
                this.fields.forEach(async (item) => {
                  if (item.key == "duty" || item.key == "duty_cause") {
                    item.options = list[item.key] ? list[item.key] : [];
                    this.$forceUpdate();
                  }
                  if (item.key == "verify_type") {
                    switch (row.work_type) {
                      case 1:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_prel"),
                            value: 2,
                          },
                        ];
                        break;
                      case 2:
                        item.options = [
                          {
                            label: this.$t("confirm") + this.$t("freight_fees"),
                            value: 1,
                          },
                        ];
                        break;
                      case 3:
                        item.options = [
                          { label: this.$t("confirm_pay"), value: 1 },
                        ];
                        break;
                      default:
                        item.options = [
                          { label: this.$t("agree"), value: 1 },
                          {
                            label: this.$t("reject_client"),
                            value: 2,
                          },
                        ];
                        break;
                    }
                  }
                });
                this.setTitle(this.$t("auditOrder") + row.airway_number);
              });
            },
            printFun({ row }) {
              this.handleMethods("print", row.id);
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
.content {
  height: 100%;
}
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
